import { Switch } from '@hive/component';
import {
  SettingRow,
  SettingWrapper,
} from '@hive/component/setting-components';
import { useAsyncCallback } from '@hive/core/components/hooks/hive-async-hooks';
import { WorkspacePermissionService } from '@hive/core/modules/permissions';
import { WorkspaceShareSettingService } from '@hive/core/modules/share-setting';
import { WorkspaceService } from '@hive/core/modules/workspace';
import { useI18n } from '@hive/i18n';
import { useLiveData, useService } from '@toeverything/infra';

export const SharingPanel = () => {
  const workspace = useService(WorkspaceService).workspace;
  if (workspace.flavour === 'local') {
    return null;
  }
  return <Sharing />;
};

export const Sharing = () => {
  const t = useI18n();
  const shareSetting = useService(WorkspaceShareSettingService).sharePreview;
  const enableUrlPreview = useLiveData(shareSetting.enableUrlPreview$);
  const loading = useLiveData(shareSetting.isLoading$);
  const permissionService = useService(WorkspacePermissionService);
  const isOwner = useLiveData(permissionService.permission.isOwner$);

  const handleCheck = useAsyncCallback(
    async (checked: boolean) => {
      await shareSetting.setEnableUrlPreview(checked);
    },
    [shareSetting]
  );

  if (!isOwner) {
    return null;
  }

  return (
    <SettingWrapper title={t['com.hive.settings.workspace.sharing.title']()}>
      <SettingRow
        name={t['com.hive.settings.workspace.sharing.url-preview.title']()}
        desc={t[
          'com.hive.settings.workspace.sharing.url-preview.description'
        ]()}
      >
        <Switch
          checked={enableUrlPreview || false}
          onChange={handleCheck}
          disabled={loading}
        />
      </SettingRow>
    </SettingWrapper>
  );
};
